import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';
import style from './float-label.module.less';

export const FloatLabel = memo(({ labelText, slideUp = false, hasError = false, className, disabled = false, inputId }) => {
  const classes = classnames(
    style['float-label-container'],
    {
      [style['slide-label-up']]: slideUp,
      [style.error]: hasError,
      [style.disabled]: disabled,
    },
    className,
  );
  return (
    <div className={classes}>
      <label data-testid='float-label' htmlFor={inputId}>
        {labelText}
      </label>
    </div>
  );
});

FloatLabel.propTypes = {
  labelText: PropTypes.node.isRequired,
  slideUp: PropTypes.bool,
  hasError: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  inputId: PropTypes.string,
};
